import { useEffect, useState, useRef } from "@wordpress/element";
import { ToolbarButton, Popover } from "@wordpress/components";
import {
    BlockControls,
    RichText,
    useBlockEditContext,
    __experimentalLinkControl as LinkControl,
} from "@wordpress/block-editor";

const NEW_TAB_REL = "noreferrer noopener";

export const LinkPopover = (props) => {
    const ref = useRef();
    // const richTextRef = useRef();
    // const [isEditingURL, setIsEditingURL] = useState(false);
    const { onChange, richTextRef, isEditingURL, setIsEditingURL } = props;
    const { linkTarget, url } = props.value || {};
    const opensInNewTab = linkTarget === "_blank";

    function unlink() {
        if (typeof props.unlink === 'function') return props.unlink();
        onChange({
            ...props.value,
            url: undefined,
            linkTarget: undefined,
            rel: undefined,
        });
        setIsEditingURL(false);
    }

    return (
        <Popover
            position="bottom center"
            onClose={() => {
                setIsEditingURL(false);
                richTextRef.current?.focus();
            }}
            anchorRef={ref?.current}
            focusOnMount={isEditingURL ? "firstElement" : false}
        >
            <LinkControl
                className="wp-block-navigation-link__inline-link-input"
                value={{ url, opensInNewTab }}
                onChange={({
                    url: newURL = "",
                    opensInNewTab: newOpensInNewTab,
                }) => {
                    onChange({ ...props.value, url: newURL });

                    if (opensInNewTab !== newOpensInNewTab) {
                        const newLinkTarget = newOpensInNewTab ? "_blank" : undefined;
                        onChange({
                            ...props.value,
                            linkTarget: newLinkTarget,
                        });
                    }
                }}
                onRemove={() => {
                    unlink();
                    richTextRef.current?.focus();
                }}
                forceIsEditingLink={isEditingURL}
            />
        </Popover>
    );
}

export default LinkPopover